import { trackOpenBets } from '@swf/core/models/sports/myBets.tracking';
import type { EffectParams, ModelConfig, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

import * as reducers from './reducers/myBets';
import type { MyBets, MyBetsState, SearchBetsQuery } from './types/myBets';

const PAGE_SIZE = 6;
const TO_RECORD_OFFSET = PAGE_SIZE - 1;

export const initialState: MyBetsState = {
  bets: [],
  cashoutQuotes: {},
  cashedOut: {},
  isFetching: false,
  moreAvailable: false,
  numberOfMatches: 0,
  isErroneous: false
};

const selectors = (slice: Slicer<MyBetsState>) => ({
  isFetching() {
    return slice((state) => state.isFetching);
  },
  isErroneous() {
    return slice((state) => state.isErroneous);
  },
  bets() {
    return slice((state) => state.bets);
  },
  cashoutQuotes() {
    return slice((state) => state.cashoutQuotes);
  },
  cashedOut() {
    return slice((state) => state.cashedOut);
  },
  moreAvailable() {
    return slice((state) => state.moreAvailable);
  }
});

const effects = {
  betsRequested: async (
    payload: SearchBetsQuery,
    { dispatch, rootState, request }: EffectParams
  ) => {
    try {
      let { fromRecord } = payload;

      // If the fromRecord isn't provided, calculate it from the local state
      if (fromRecord === undefined) {
        fromRecord = select.myBets.bets(rootState).length + 1;
      }

      const result = await request<MyBets>({
        service: '/sports/web/my-bets',
        body: {
          fromRecord,
          toRecord: payload.toRecord ?? fromRecord + TO_RECORD_OFFSET,
          ...payload
        }
      });

      dispatch.myBets.betsLoadedSuccessfully(result.body);

      trackOpenBets(result.body);
    } catch {
      dispatch.myBets.betsLoadedUnsuccessfully();
    }
  }
};

interface MyBetsModel extends ModelConfig<MyBetsState> {
  selectors: typeof selectors;
  effects: typeof effects;
  reducers: typeof reducers;
}

const myBets: MyBetsModel = {
  state: { ...initialState },
  selectors,
  effects,
  reducers
};

export default myBets;
